import './style.css'
import { GameManager } from './managers/GameManager'

// Initialize the game
document.addEventListener('DOMContentLoaded', () => {
  const gameManager = new GameManager()
  gameManager.init()
})
